import React from "react";

export const LazyUsersMultiSelectAutoUpdateBridge = React.lazy(
    () =>
        import(
            /* webpackChunkName: "SelectAutoUpdate" */ "./UsersMultiSelectAutoUpdate"
        )
);
